"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeStorage = void 0;
var TypeStorage;
(function (TypeStorage) {
    /**
     * 앱 저장소에 데이터 저장을 요청해요
     * @required key   저장할 데이터의 키 값
     * @required value 데이터
     */
    TypeStorage["ReqStorageSet"] = "REQ.STORAGE.SET";
    /**
     * 앱 저장소에 저장된 데이터 읽기를 요청해요
     * @required key 조회할 데이터의 키 값
     */
    TypeStorage["ReqStorageGet"] = "REQ.STORAGE.GET";
    /**
     * 앱 저장소에 저장된 전체 데이터 읽기를 요청해요
     */
    TypeStorage["ReqStorageGetAll"] = "REQ.STORAGE.GET_ALL";
    /**
     * 앱 저장소에 저장된 데이터 제거를 요청해요
     * @required key 제거할 데이터의 키 값
     */
    TypeStorage["ReqStorageDelete"] = "REQ.STORAGE.DELETE";
    /**
     * 앱 저장소에 저장된 데이터를 반환해요
     * @required key   해당 데이터의 키 값
     * @required value 해당 데이터
     */
    TypeStorage["ResStorageGet"] = "RES.STORAGE.GET";
    /**
     * 앱 저장소에 저장된 모든 데이터를 반환해요
     * @required values 모든 데이터
     */
    TypeStorage["ResStorageGetAll"] = "RES.STORAGE.GET_ALL";
})(TypeStorage = exports.TypeStorage || (exports.TypeStorage = {}));
//# sourceMappingURL=Storage.js.map